import React, { useState } from 'react';
import styled from 'styled-components';
import { AppCard } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import Translator from '../../../../components/helpers/Translator';
import colors from '../../../../../constants/colors';

export default function ModuleComsaEnvironmentalConstructionDesignNormalAspectsCard(
  props
) {
  const { motive, data } = props;
  const [riskEvaluationText] = useState([
    <Translator file="module-comsaEnvironmental" name="no.applicable" />,
    <Translator file="module-comsaEnvironmental" name="not-significant" />,
    <Translator file="module-comsaEnvironmental" name="significant" />,
  ]);

  return (
    <Container className="mb-2" bodyClassName="p-1">
      <div className="info-block">
        <div className="line mb-2">
          <div>
            <Translator file="module-comsaEnvironmental" name="reason" />:
          </div>
          <div>
            <b>{motive}</b>
          </div>
        </div>
        <div className="line mb-2">
          <div>
            <Translator
              file="module-comsaEnvironmental"
              name="risk.assessment"
            />
            :
          </div>
          <div
            className={
              data?.riskEvaluation === 2
                ? 'text-danger'
                : data?.riskEvaluation === 1
                ? 'text-warning'
                : 'text-success'
            }
          >
            <b>{riskEvaluationText[data?.riskEvaluation] || ''}</b>
          </div>
        </div>
      </div>
    </Container>
  );
}

const Container = styled(AppCard)`
  .info-block {
    display: flex;
    text-align: center;
    flex-direction: column;
    @media (min-width: 768px) {
      flex-direction: row;
    }
    .line {
      flex: 1 1;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: ${colors.primaryLight};
    }
  }
`;
